import { Injectable } from '@angular/core';
import { DbRecord } from './db-record'
import { RuntimeService } from './runtime.service'
import { Project } from './project'

@Injectable()
export class PatentService {
  rts: RuntimeService

  countriesMap = new Map<string, Set<string>>()
  stagesMap = new Map<string, Set<string>>()

  countriesFilter = new Set<string>()
  stagesFilter = new Set<string>()

  constructor(
    //  private rs: RuntimeService
  ) { }

  processDbRecord(dbr: DbRecord) {
    let p = this.rts.currentProject

    let cs = this.countriesMap.get(p.id)
    if (!cs) {
      cs = new Set<string>()
      this.countriesMap.set(p.id, cs)
    }
    dbr.patentCountries.forEach(x => cs.add(x))

    let ss = this.stagesMap.get(p.id)
    if (!ss) {
      ss = new Set<string>()
      this.stagesMap.set(p.id, ss)
    }
    dbr.patentStages.forEach(x => ss.add(x))
  }

  patentCountriesLs(project: Project) {
    let ls = Array.from(this.countriesMap.get(project.id))
    ls.sort((a, b) => a < b ? -1 : 1)
    return ls
  }

  patentStagesLs(project: Project) {
    let ls = Array.from(this.stagesMap.get(project.id))
    ls.sort((a, b) => a < b ? -1 : 1)
    return ls
  }

  setFilter(tp: string, value: string) {
    let f
    switch (tp) {
      case 'country': f = this.countriesFilter; break;
      case 'stage': f = this.stagesFilter; break;
    }
    if (!f.delete(value))
      f.add(value)
  }

  isSelectedFilter(tp: string, value: string) {
    let f
    switch (tp) {
      case 'country': f = this.countriesFilter; break;
      case 'stage': f = this.stagesFilter; break;
    }
    return f.has(value)
  }

  filter(ls: DbRecord[]) {
    if (this.countriesFilter.size)
      ls = ls.filter(x => x.hasCountry(this.countriesFilter))
    if (this.stagesFilter.size)
      ls = ls.filter(x => x.hasStage(this.stagesFilter))
    return ls
  }

}



// WEBPACK FOOTER //
// ./src/app/patent.service.ts